<mat-sidenav-container>
    <section class="info mb-4 flex justify-center items-center gap-4">
        <p class="hidden sm:block">Made with</p>
        <img matTooltip="Angular" src="assets/icon_angular.png" class="h-9 w-9 hidden sm:block"
            alt="Angular framework logo" />
        <p class="hidden sm:block">and</p>
        <img matTooltip="Angular Material"
            src="https://angular.io/generated/images/marketing/concept-icons/material.svg"
            class="h-7 w-7 hidden sm:block" alt="Angular Material logo" />
        <p>by</p>
        <img matTooltip="Voidtrack" src="favicon.png" alt="Voidtrack logo" class="h-8 w-8" />
        <p>in 2025</p>
        <p>|</p>
        <p>Hosted on</p>
        <img matTooltip="GitHub" src="assets/github-mark.svg" alt="GitHub logo" class="h-8 w-8" role="button"
            (click)="openPost('https://github.com/Voidtrack/taglensr')" />
    </section>
    <header class="px-3 w-full flex justify-center items-center gap-4">
        <mat-icon class="hidden sm:block" fontIcon="info" />
        <p>Tumblr has a known bug in their tag API that prevents some posts from being shown</p>
        <a href="https://github.com/tumblr/docs/issues/136" target="_blank">GitHub issue</a>
    </header>
    <main class="flex w-full flex-col flex-wrap justify-center items-center gap-4 mb-12">
        <link rel="preload" as="image" href="assets/logo.svg" fetchpriority="high" />
        <img fetchpriority="high" alt="Taglensr logo" src="assets/logo.svg" class="my-6 w-11/12 sm:w-auto sm:h-28" />
        <h2 class="hidden md:block">A small, advanced listing utility for Tumblr tags and blogs -- Peer into
            hellsite (affectionate) history!
        </h2>
        <section class="flex flex-col flex-wrap justify-center items-center gap-5">
            <section class="flex flex-col md:flex-row flex-wrap justify-center items-center gap-4">
                <mat-form-field subscriptSizing="dynamic">
                    <mat-label>Search tag or blog</mat-label>
                    <mat-icon matIconPrefix aria-hidden="true" fontIcon="search" />
                    <input matInput required="true" type="text" placeholder="#cats/@tumblr" [(ngModel)]="target"
                        [value]="target" (input)="resetNav()">
                </mat-form-field>
                <mat-form-field subscriptSizing="dynamic">
                    <mat-label>Search before</mat-label>
                    <input matInput type="date" [(ngModel)]="selectedDate" [value]="selectedDate" (input)="resetNav()">
                </mat-form-field>
            </section>
            <app-type-select (type)="filterType = $event" (input)="resetNav()" />
            <section class="flex flex-col flex-wrap justify-center items-center gap-4">
                <p>Number of posts</p>
                <mat-slider class="w-72 md:w-96" min="1" max="20" step="1" showTickMarks discrete>
                    <input matSliderThumb aria-label="Number of posts" [(ngModel)]="requestedPostCount"
                        [value]="requestedPostCount" (input)="resetNav()">
                </mat-slider>
                <button mat-flat-button color="primary" (click)="search()">
                    <mat-icon aria-hidden="true" fontIcon="search" />
                    Search
                </button>
            </section>
        </section>

        <section class="columns-xs px-16 w-full">
            @for (post of posts; track $index) {
            <mat-card (click)="this.openPost(post.link)" role="button" class="my-4 break-inside-avoid-column">
                <img mat-card-image [src]="post.photo" />
                @if (post.summary.length !== 0) {
                <mat-card-content>
                    <p>{{post.summary}}</p>
                </mat-card-content>
                }
            </mat-card>
            }
        </section>
        @if (this.loading) {
        <mat-spinner />
        <p>Going back to {{this.internalDate}} for your posts...</p>
        @if (this.requestsMade > ((this.REQUEST_LIMIT * this.requestedPostCount) / 2)) {
        <p>We're going back further than expected</p>
        }
        }
        @if (!this.loading && !this.pendingSearch) {
        <button mat-flat-button color="primary" (click)="backInTime()">
            <mat-icon aria-hidden="true" fontIcon="arrow_forward" />
            Next
        </button>
        }
    </main>
</mat-sidenav-container>